<template>

  <div>
    <div>
      <form 
        class="input-group"
        v-on:submit.prevent="onFilterSearch">
        <input 
          type="text" 
          class="form-control" 
          placeholder="Search" 
          v-model="searchValue">
        <div class="input-group-append">
          <button 
            class="btn btn-info" 
            v-on:click.prevent="onFilterSearch">
            Search
          </button>
        </div>
      </form>
    </div>
  </div>
  
</template>

<script>

export default {
  name: "AppSearch",
  data() {
    return {
      searchValue: undefined,
    };
  },
  methods: {
    onFilterSearch() {
      this.$emit('search-data-change', this.searchValue);
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/App/AppSearch.vue